export type { CopilotKitCSSProperties } from "./css";
